import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT } from '../../../../styles/theme'

interface OpenResponsesViewProps {
  answers: string[]
  isPrinting: boolean
}

const SectionLabel = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--color-text-secondary);
  margin-bottom: ${SPACING.md};
`

const QuoteList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};
`

const QuoteCard = styled.div`
  border-left: 3px solid rgba(110, 83, 249, 0.25);
  padding: ${SPACING.md} ${SPACING.lg};
  background: var(--color-bg-secondary);
  border-radius: 0 ${BORDER_RADIUS.md} ${BORDER_RADIUS.md} 0;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: 1.55;
  color: var(--color-text-primary);
`

const NoData = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-secondary);
  text-align: center;
  padding: ${SPACING.xl} 0;
`

export function OpenResponsesView({ answers, isPrinting }: OpenResponsesViewProps) {
  if (answers.length === 0) {
    return <NoData>No responses yet</NoData>
  }

  const visibleQuotes = isPrinting ? answers.slice(0, 20) : answers

  return (
    <>
      <SectionLabel>Responses ({answers.length})</SectionLabel>
      <QuoteList>
        {visibleQuotes.map((text, i) => (
          <QuoteCard key={i}>{text}</QuoteCard>
        ))}
      </QuoteList>
    </>
  )
}
